module.exports = __webpack_public_path__ + "static/img/top-bg03_1.dc1a881.webp";